import { FunctionComponent, useState } from 'react';
import { Button } from '@shopify/polaris';
import styled from 'styled-components';
import TagsStack from '../tags-stack';
import Input from '../input';

const Container = styled.div<{ disabled?: boolean }>`
  .Polaris-Connected {
    margin: 10px 0;
  }
  .Polaris-Tag {
    margin-right: 5px;
  }
`;

const TagsInput: FunctionComponent<{
  actionText: string;
  initialSelected?: string[];
  onAddedTag?: (tags: string[]) => void;
  onValidateInput: (value: string) => boolean;
}> = ({ actionText, initialSelected = [], onAddedTag, onValidateInput }) => {
  const [tags, setTags] = useState(initialSelected);
  const [text, setText] = useState('');
  const onClickCancel = (value: string) => {
    const newTags = tags.filter((tag) => tag !== value);
    setTags(newTags);
    if (onAddedTag) {
      onAddedTag(newTags);
    }
  };

  const onAddTag = () => {
    const newTags = Array.from(new Set([...tags, text]).values());
    setTags(newTags);
    setText('');
    if (onAddedTag) {
      onAddedTag(newTags);
    }
  };

  const disableButton = text === '' || !onValidateInput(text);

  return (
    <Container>
      <Input
        label=""
        value={text}
        onChange={setText}
        connectedRight={
          <Button disabled={disableButton} onClick={onAddTag}>
            {actionText}
          </Button>
        }
      />

      <TagsStack initialSelected={tags} onCancel={onClickCancel} />
    </Container>
  );
};

export default TagsInput;
